import {
  initialState,
  Actions,
  State,
  DELETE_CUSTOM_CONTENT_TYPE,
  DELETE_CUSTOM_CONTENT_TYPE_SUCCESS,
  DELETE_CUSTOM_CONTENT_TYPE_ERROR,
  RESET_DELETE_CUSTOM_CONTENT_TYPE,
} from '../../types/custom-content-tye/delete'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case DELETE_CUSTOM_CONTENT_TYPE:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case DELETE_CUSTOM_CONTENT_TYPE_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case DELETE_CUSTOM_CONTENT_TYPE_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_DELETE_CUSTOM_CONTENT_TYPE:
      return {
        ...state,
        ...initialState,
      }
    default:
      return state
  }
}

export default reducers
